<ng-container *transloco="let t;">
  <ng-container *ngIf="tabs?.length > 0">
    <ul class="p-mb-4">
      <li *ngFor="let actual of tabs" [class.active]="active?.value === actual.value">
        <i *ngIf="docMode" class="pi pi-file"></i>
        <strong *ngIf="active?.value === actual.value">
          {{ actual.label }}
        </strong>
        <a *ngIf="active?.value !== actual.value" (click)="onChangeTab(actual)">
          {{ actual.label }}
        </a>
      </li>
    </ul>
  </ng-container>
</ng-container>
